export class StatusGraphQLCodes {
    static FORBIDDEN: string = 'FORBIDDEN';
    static UNAUTHENTICATED: string = 'UNAUTHENTICATED';
    static BAD_USER_INPUT: string = 'BAD_USER_INPUT';
}
